import { jsx } from 'react/jsx-runtime';
import { useResourceBookmarkDataSafe } from '../../../../../resource-detail/components/context/resourceDataContext.js';
import { FaviconImage } from '../../../../../resource-detail/components/FaviconImage.js';
import { IconBookmark } from '@fabric-app/icons/svg';
import { styled } from 'styled-components';

const ResourcePreviewListItemPage = () => {
  const { resource } = useResourceBookmarkDataSafe();
  return /* @__PURE__ */ jsx(StyledFaviconImage, {
    faviconUrl: resource.data.webpage?.favicon?.url,
    pageUrl: resource.originUrl,
    PlaceholderIcon: IconBookmark
  });
};
const StyledFaviconImage = styled(FaviconImage).withConfig({
  displayName: "ResourcePreviewListItemPage__StyledFaviconImage",
  componentId: "sc-4eb0b843-0"
})([
  `width:1.5rem;height:1.5rem;`
]);

export { ResourcePreviewListItemPage };
//# sourceMappingURL=ResourcePreviewListItemPage.js.map
